export default {
  version: 'master',
  compilation: '176561'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1481
// module chunks = 22